import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from "prop-types"; 

function Breadcrumbs({ items, className = "", separator = "/" }) {
    if (!items?.length) return null;
    return (
    <div>
        <nav className={`breadcrumbs ${className}`} aria-label="Breadcrumb">
        <ol class="breadcrumbs__list">
            {items.map((item, idx) => {
                const isLast = idx === items.length - 1;
                const key = item.to ?? `${item.label}-${idx}`;
                return (
                    <li className="breadcrumbs__item" key={key}>
                    {isLast || !item.to ? (
                        <span className="breadcrumbs__link breadcrumbs__link--current" aria-current="page">
                        {item.label}
                        </span>
                    ) : (
                        <Link className="breadcrumbs__link" to={item.to}>
                        {item.label}
                        </Link>
                    )}
                    {!isLast && (
                        <span className="breadcrumbs__sep" aria-hidden="true">
                        {separator}
                        </span>
                    )}
                    </li>                    
                );
            })}
            {/* <li class="breadcrumbs__item"><a href="../index.html">Home</a></li>
            <li class="breadcrumbs__item"><a href="industeries.html">Solutions</a></li>
            <li class="breadcrumbs__item" aria-current="page">water-well</li> */}
        </ol>
        </nav>
    </div>
  )
}

export default Breadcrumbs

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      to: PropTypes.string, // omit or leave empty for the current/last item
    })
  ).isRequired,
  className: PropTypes.string,
  separator: PropTypes.node,
};